import React from "react";
import { useState, useEffect, useCallback } from "react";
import { Col, Row } from "react-bootstrap";
import api from "../../services/api";
import { toast } from "react-toastify";
import DatePicker from "../../components/DatePicker";
import useWrapper from "../../hooks/useWrapper";
import getSurvey from "../../util/getSurvey";
import ModalCustom from "./modal-template-default";
import Loading from "../Loading";
import useFormat from "../../hooks/utils/useFormat";
import Survey from "../Survey";
import Button from "../Button";
import ButtonActions from "../Button/ButtonActions";
import { validateForm, validateStyle } from "../ValidateForm";

export default function ModalAnswer(props) {
  const { show, survey_id, refreshCallback, onHide } = props;
  const { me, config } = useWrapper();
  const { formatDate } = useFormat();

  const [isWaitingResponse, setisWaitingResponse] = useState(true);
  const [isLoadingEssential, setisLoadingEssential] = useState(true);
  const [isLoadingSave, setisLoadingSave] = useState(false);
  useEffect(() => {
    setisWaitingResponse(isLoadingEssential || isLoadingSave);
  }, [isLoadingEssential, isLoadingSave]);

  const [reload, setreload] = useState();
  const [survey, setsurvey] = useState();

  const loadSurvey = useCallback(async () => {
    try {
      setisLoadingEssential(true);
      const _survey = await getSurvey({
        query: `/${survey_id}`,
        config,
        ...(me?.type === "Gestor" ? { user_id: me?.id } : { trainee_id: me?.id }),
      });
      setsurvey(_survey);
    } catch (__error) {
      console.log("__error", __error);
      toast.error("Erro ao tentar carregar as enquetes.");
    } finally {
      setisLoadingEssential(false);
    }
  }, [survey_id, config, me]);
  useEffect(() => {
    !!survey_id && loadSurvey();
  }, [survey_id, loadSurvey]);

  useEffect(() => {
    !!reload && loadSurvey();
  }, [reload, loadSurvey]);

  const [selects, setselects] = useState();
  const closeNReset = () => {
    setselects();
    onHide();
  };

  const confirmVote = async () => {
    try {
      setisLoadingSave(true);
      await api.post(
        "trainee/survey-answer",
        {
          survey_id: survey?.id,
          survey_option_id: selects?.survey,
          trainee_id: me?.id,
          // event_id: survey?.event_id,
        },
        config,
      );
      toast.success("Voto confirmado com sucesso.");
    } catch (__error) {
      toast.error("Erro ao tentar votar. Entre em contato com a nossa Equipe.");
      console.log("__error", __error);
    } finally {
      refreshCallback();
      setreload(JSON.stringify(new Date()));
      setisLoadingSave(false);
    }
  };

  const closeSurvey = async () => {
    try {
      setisLoadingSave(true);
      await api.put(`${!!me?.is_member ? "trainee/" : ""}survey/${survey?.id}`, { open: false }, config);
      toast.success("Enquete encerrada com sucesso.");
    } catch (__error) {
      toast.error("Erro ao tentar votar. Entre em contato com a nossa Equipe.");
      console.log("__error", __error);
    } finally {
      refreshCallback();
      setisLoadingSave(false);
      closeNReset();
    }
  };

  const updateDate = async _date => {
    const _is_valid = validateForm(document.getElementById("survey"));
    if (!_is_valid) return;

    try {
      setisLoadingSave(true);
      await api.put(
        `${!!me?.is_member ? "trainee/" : ""}survey/${survey?.id}`,
        { expires_date: _date || survey?.expires_date },
        config,
      );
      toast.success("Enquete atualizada com sucesso.");
    } catch (__error) {
      toast.error("Erro ao tentar atualizar enquete.");
      console.log("__error", __error);
    } finally {
      refreshCallback();
      setisLoadingSave(false);
      closeNReset();
    }
  };

  return (
    <ModalCustom
      size="md"
      show={show}
      onHide={closeNReset}
      disableClose={isWaitingResponse}
      id="survey"
      style={validateStyle}
    >
      <>
        {!isLoadingEssential ? (
          <>
            <ModalCustom.Header>
              <ModalCustom.Title>Enquete {survey?.status}</ModalCustom.Title>
            </ModalCustom.Header>
            <ModalCustom.Body>
              <p className="m-0">
                <b>Enquete: </b>
                {survey?.description}
              </p>
              <Row>
                <Col>
                  {((!!me?.is_member && !survey?.only_admin_edit) || me?.type === "Gestor") && !!survey?.open ? (
                    <>
                      <div className="divisor mt-2 mb-2"></div>
                      <span>Encerramento</span>
                      <DatePicker
                        required={true}
                        disabled={!!isWaitingResponse}
                        selected={survey?.expires_date}
                        changeDate={ev => {
                          setsurvey({
                            ...survey,
                            expires_date: ev,
                          });
                        }}
                        minDate={new Date()}
                      />
                    </>
                  ) : (
                    <p className="small-label">
                      <b>Encerramento:</b> {formatDate(survey?.expires_date, 2)}
                    </p>
                  )}
                </Col>
              </Row>
              <div className="divisor mt-3 mb-3"></div>
              <Survey
                disabled={survey?.status !== "Aguardando Voto"}
                value={survey?.voted || selects?.survey}
                options={survey?.surveyOptions?.map(__survey => ({
                  value: __survey.id,
                  label: __survey.quest,
                  percent: __survey.votes_percent,
                }))}
                valueChange={__ev => {
                  setselects({
                    ...selects,
                    survey: __ev,
                  });
                }}
              />
            </ModalCustom.Body>

            {!!survey?.open && (
              <>
                <ModalCustom.Footer>
                  {((!!me?.is_member && !survey?.only_admin_edit) || me?.type === "Gestor") && (
                    <ButtonActions
                      disabled={!!isWaitingResponse}
                      options={[
                        {
                          label: "Cancelar Enquete",
                          onClick: closeSurvey,
                        },
                        {
                          label: "Encerrar Enquete",
                          onClick: () => {
                            const _today = new Date();
                            const _yesterday = new Date(
                              _today?.getFullYear(),
                              _today?.getMonth(),
                              _today?.getDate() - 1,
                            );
                            updateDate(_yesterday);
                          },
                        },
                        {
                          label: "Atualizar Data",
                          onClick: updateDate,
                        },
                      ]}
                    />
                  )}
                  {me?.type === "Formando" && survey?.status === "Aguardando Voto" && (
                    <Button color="success" onClick={confirmVote} disabled={!!isWaitingResponse || !selects?.survey}>
                      Confirmar Voto
                    </Button>
                  )}
                </ModalCustom.Footer>
              </>
            )}
          </>
        ) : (
          <ModalCustom.Body>
            <Loading />
          </ModalCustom.Body>
        )}
      </>
    </ModalCustom>
  );
}
